import { Container, interfaces } from 'inversify'
import Newable = interfaces.Newable
import Abstract = interfaces.Abstract
import Context = interfaces.Context

export const container = new Container()

class DependencyInjector {
  public bind<T>(type: string | symbol | Newable<T> | Abstract<T>, impl?: Newable<T>) {
    if (impl === undefined) {
      impl = type as Newable<T>
    }

    container.bind(type).to(impl)
  }

  public bindConstant<T>(type: string | symbol, value: T) {
    container.bind(type).toConstantValue(value)
  }

  public bindLazy<T>(
    type: string | symbol | Newable<T> | Abstract<T>,
    factory: (context: Context) => T
  ) {
    container
      .bind(type)
      .toDynamicValue(factory)
      .inSingletonScope()
  }

  public bindSingleton<T>(type: Newable<T>) {
    return this.bindLazy(type, () => new type())
  }

  public get<T>(type: string | Newable<T>): T {
    return container.get<T>(type)
  }
}

export const Injector = new DependencyInjector()
